import i18n from 'i18next';
import LanguageDetector, {
  DetectorOptions,
} from 'i18next-browser-languagedetector';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import yaml from 'js-yaml';
import { initReactI18next } from 'react-i18next';

import { dpConfig } from 'src/config';
import { PreferencesParam } from 'src/enums/PreferencesParam';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions & DetectorOptions>({
    ns: ['common', 'navigation', 'forecast', 'preferences', 'novelties'],
    react: { useSuspense: false },
    defaultNS: 'common',
    cleanCode: true,
    fallbackLng: dpConfig.language.fallback,
    detection: {
      order: ['localStorage', 'navigator'],
      convertDetectedLanguage: (lng) => lng.substring(0, 2),
      lookupLocalStorage: PreferencesParam.LANGUAGE,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.yaml',
      parse: (data: string): { [key: string]: unknown } =>
        yaml.load(data) as { [key: string]: unknown },
    },
  });

export default i18n;
